import {
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { api } from "./api";

export interface DenylistEntry {
  id: number;
  key_type: string;
  value: string;
  reason: string | null;
  created_by: string | null;
  created_at: string;
}

const KEY = (projectId: number) => ["admin", "denylist", projectId] as const;

export function useDenylist(projectId: number | null) {
  return useQuery<{ items: DenylistEntry[] }>({
    queryKey: KEY(projectId ?? 0),
    queryFn: () => api(`/admin/projects/${projectId}/denylist`),
    enabled: projectId !== null && projectId > 0,
    staleTime: 30_000,
  });
}

export function useAddDenylistEntry(projectId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { keyType: string; value: string; reason?: string }) =>
      api<{ ok: true; id: number }>(`/admin/projects/${projectId}/denylist`, {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(projectId) }),
  });
}

export function useRemoveDenylistEntry(projectId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (entryId: number) =>
      api<{ ok: true }>(`/admin/projects/${projectId}/denylist/${entryId}`, {
        method: "DELETE",
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(projectId) }),
  });
}
